
































export default {
	name: 'SearchInput',

	props: {
		name: {
			required: true,
			type: String,
		},
		value: {
			required: false,
			type: [String, Number],
		},
		placeholder: {
			default: 'Search',
			required: false,
			type: String,
		},
		border: {
			default: true,
			required: false,
			type: Boolean,
		},
		loading: {
			default: false,
			required: false,
			type: Boolean,
		},
		icon: {
			default: true,
			required: false,
			type: Boolean,
		},
	},

	computed: {
		appleDevice() {
			return navigator.platform.indexOf('Mac') > -1;
		},
	},

	created() {
		window.addEventListener('keydown', this.searchListener);
	},

	destroyed() {
		window.removeEventListener('keydown', this.searchListener);
	},

	methods: {
		searchListener(event) {
			if (event.key === 'k' && (event.ctrlKey || event.metaKey)) {
				this.$refs.searchInput.focus();
			}
		},
		updateValue(value: string) {
			this.$emit('input', value);
		},
	},
};
